import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';

import {IconBoldMapComponent} from '@components/icons/icon-bold-map/icon-bold-map.component';
import {IconBoldReceipt2Component} from '@components/icons/icon-bold-receipt-2/icon-bold-receipt-2.component';
import {IconBoldHeatComponent} from '@components/icons/icon-bold-heat/icon-bold-heat.component';
import {IconBoldAddSquare} from '@components/icons/icon-bold-add-square/icon-bold-add-square';

@Component({
    selector: 'app-header-botoes-flutuantes-mapa',
    standalone: true,
    imports: [RouterModule, ButtonModule, IconBoldMapComponent, IconBoldReceipt2Component, IconBoldHeatComponent, IconBoldAddSquare],
    templateUrl: './header-botoes-flutuantes-mapa.component.html',
    styleUrl: './header-botoes-flutuantes-mapa.component.css'
})
export class HeaderBotoesFlutuantesMapa {

}
